import { Calendar } from '@fullcalendar/core';
import interactionPlugin from '@fullcalendar/interaction';
import TimeGridPlugin from '@fullcalendar/timegrid';
import itLocale from '@fullcalendar/core/locales/it';

import Utils from './utils';

class MyCalendar
{
    static init()
    {
        /*
            Calendario degli appuntamenti
        */
        let calendar = document.getElementById('calendar');
        if (calendar) {
            let cal = $(calendar);

            let options = {
                plugins: [interactionPlugin, TimeGridPlugin],
                timeZone: 'UTC',
                locale: itLocale,
                initialView: 'enabled',
                slotMinTime: cal.attr('data-start-hour'),
                slotMaxTime: cal.attr('data-end-hour'),
                selectable: true,
                allDaySlot: false,
                slotDuration: '00:30:00',
                dayHeaderFormat: {
                    weekday: 'short',
                    month: 'numeric',
                    day: 'numeric',
                    omitCommas: true,
                },
                headerToolbar: {
                    left: 'prev,next today',
                    center: '',
                    right: '',
                },
                eventContent: function(info) {
                    return {
                        html: info.timeText + '<br>' + info.event.title
                    };
                },
                views: {
                    enabled: {
                        type: 'timeGridWeek',
                        hiddenDays: [0],
                    }
                },
                dateClick: (info) => {
                    let url = $('.create-session-btn').attr('href');
                    window.location.href = url + '?date=' + info.dateStr;
                },
                events: (info, successCallback, failureCallback) => {
                    /*
                        Qui combino gli estremi dati dal calendario (data di
                        inizio e fine della settimana correntemente
                        visualizzata) con i parametri del filtro di ricerca
                    */
                    let form = $('#calendar-filters form');
                    let data = form.serializeArray().concat([
                        {
                            name: 'start',
                            value: info.startStr,
                        },
                        {
                            name: 'end',
                            value: info.endStr,
                        },
                    ]);

                    $.ajax({
                        url: form.attr('action'),
                        method: 'GET',
                        data: data,
                        dataType: 'JSON',
                        success: (data) => {
                            let hidden = [0, 1, 2, 3, 4, 5, 6].filter(x => data.days.includes(x) === false);
                            if (hidden.length != 7) {
                                /*
                                    FullCalendar non la prende bene se si
                                    provano a nascondere tutti i giorni della
                                    settimana
                                */
                                this.calendar.setOption('hiddenDays', hidden)
                            }

                            successCallback(data.events);
                        }
                    });
                }

                /*
                    TODO: Per fare in modo di distinguere quale disponibilità è
                    stata selezionata, pur tenendo l'informazione su giorno e
                    ora cliccati, esplorare i diversi link che si trovano qui
                    https://github.com/fullcalendar/fullcalendar/issues/2430
                */
            };

            /*
                All'occorrenza, inizializza i filtri per il calendario
            */
            if ($('#calendar-filters').length) {
                options.customButtons = {
                    filter: {
                        text: 'Filtri',
                        click: function() {
                            $('#calendar-filters').modal('show');
                        }
                    }
                };

                options.headerToolbar.left = 'filter prev,next today';

                $('#calendar-filters form').submit((e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    this.calendar.refetchEvents();
                    $(e.currentTarget).closest('.modal').modal('hide');
                });
            }

            this.calendar = new Calendar(calendar, options);
            this.calendar.render();
            this.calendar.refetchEvents();
        }

        /*
            Calendario delle disponibilità
        */
        let availabilities = document.getElementById('availabilities');
        if (availabilities) {
            let cal = $(availabilities);

            this.calendar = new Calendar(availabilities, {
                plugins: [interactionPlugin, TimeGridPlugin],
                timeZone: 'Europe/Rome',
                locale: itLocale,
                initialView: 'timeGridWeek',
                nowIndicator: false,
                slotMinTime: cal.attr('data-start-hour'),
                slotMaxTime: cal.attr('data-end-hour'),
                allDaySlot: false,
                slotDuration: '00:30:00',
                height: 400,
                headerToolbar: false,
                events: window.availabilities_url,
                longPressDelay: 1,
                selectable: true,
                selectMirror: true,
                dayHeaderContent: (date) => {
                    return date.date.toLocaleString('it-it', {
                        weekday: 'long'
                    });
                },
                select: function(arg) {
                    $.ajax({
                        url: window.create_availability_url,
                        data: {
                            start: arg.startStr,
                            end: arg.endStr,
                        },
                        method: 'GET',
                        dataType: 'HTML',
                        success: (data) => {
                            let modal = $(data);
                            Utils.j().initElements(modal);
                            modal.modal('show');
                        }
                    });
                },
                eventClick: function(info) {
                    $.ajax({
                        url: info.event.extendedProps.modal_url,
                        method: 'GET',
                        dataType: 'HTML',
                        success: (data) => {
                            let modal = $(data);
                            Utils.j().initElements(modal);
                            modal.modal('show');
                        }
                    });
                },
            });

            this.calendar.render();
        }

        /*
            Calendario statico delle disponibilità
        */
        let staticAvailabilities = document.getElementById('staticAvailabilities');
        if (staticAvailabilities) {
            let cal = $(staticAvailabilities);

            this.calendar = new Calendar(staticAvailabilities, {
                plugins: [TimeGridPlugin],
                timeZone: 'Europe/Rome',
                locale: itLocale,
                initialView: 'timeGridWeek',
                nowIndicator: false,
                slotMinTime: cal.attr('data-start-hour'),
                slotMaxTime: cal.attr('data-end-hour'),
                allDaySlot: false,
                slotDuration: '00:30:00',
                height: 400,
                headerToolbar: false,
                events: window.availabilities_url,
                selectable: false,
                selectMirror: true,
                dayHeaderContent: (date) => {
                    return date.date.toLocaleString('it-it', {
                        weekday: 'long'
                    });
                }
            });

            this.calendar.render();
        }
    }

    static refetch()
    {
        this.calendar.refetchEvents();
        this.calendar.render();
    }
}

export default MyCalendar;
